import type { ReactNode } from "react";
import { cn } from "./cn";

export interface CardProps {
  children: ReactNode;
  className?: string;
}

export function Card({ children, className }: CardProps) {
  return (
    <div className={cn("rounded-lg border border-line bg-surface shadow-card", className)}>
      {children}
    </div>
  );
}

export interface StatTileProps {
  label: string;
  value: ReactNode;
  /** Period-over-period movement, rendered green when up and red when down. */
  delta?: { value: number; suffix?: string } | undefined;
  note?: ReactNode;
  className?: string;
}

/** The replacement for `IconComponentPanel` / the hand-rolled KPI cards. */
export function StatTile({ label, value, delta, note, className }: StatTileProps) {
  return (
    <Card className={cn("p-4", className)}>
      <p className="text-[11px] font-medium uppercase tracking-wider text-ink-faint">{label}</p>
      <p className="tabular mt-2 text-2xl font-semibold leading-none text-ink">{value}</p>
      {(delta || note) && (
        <div className="mt-2 flex items-baseline gap-2 text-[12px]">
          {delta && (
            <span className={cn("tabular font-medium", delta.value >= 0 ? "text-ok" : "text-risk")}>
              {delta.value >= 0 ? "▲" : "▼"} {Math.abs(delta.value).toFixed(1)}
              {delta.suffix ?? "%"}
            </span>
          )}
          {note && <span className="text-ink-faint">{note}</span>}
        </div>
      )}
    </Card>
  );
}
